import { defineNuxtPlugin } from '#app'
import dayjs from 'dayjs'
import 'dayjs/locale/sk'
import skLocale from 'dayjs/locale/sk'

/** Mesiac v genitíve (napr. „15. augusta 2023“) – štandardný `sk` locale má nominatív. */
const SK_MONTHS_GENITIVE = [
    'januára',
    'februára',
    'marca',
    'apríla',
    'mája',
    'júna',
    'júla',
    'augusta',
    'septembra',
    'októbra',
    'novembra',
    'decembra',
]

const skGenitiveLocale = {
    ...skLocale,
    name: 'sk-genitive',
    months: SK_MONTHS_GENITIVE,
}

export default defineNuxtPlugin(() => {
    return {
        provide: {
            date: (
                date: string,
                format: string = useRuntimeConfig().public.DATE_FORMAT,
                genitive: boolean = false
            ): string => {
                dayjs.locale(genitive ? skGenitiveLocale : skLocale)
                return dayjs(date).format(format)
            },
        },
    }
})
